import weddingIcon from "../../assets/image/inventory/ring.png";
import movieIcon from "../../assets/image/inventory/movie.png";
import chromeIcon from "../../assets/image/inventory/com.png";
import cryptoIcon from "../../assets/image/inventory/coin.png";
import bentoIcon from "../../assets/image/inventory/note.png";

export const PROJECT_INVENTORY_ICONS: Record<string, string> = {
  wedding: weddingIcon,
  flickfacts: movieIcon,
  chromeapp: chromeIcon,
  crypto: cryptoIcon,
  bento: bentoIcon,
};